import {
  UpdateCartHandler,
  ICartItemForUpdate,
  IUpdateItemsOptions,
} from "@faire/deprecated-retailer-visitor-shared/stores/domain/CartStore/consts";

export const getUpdateCartFunction =
  (
    updateFn: UpdateCartHandler,
    skipItemInventoryFetch: boolean
  ): UpdateCartHandler =>
  (items: ICartItemForUpdate[], options: IUpdateItemsOptions) =>
    updateFn(items, {
      ...options,
      // When item-inventory API is called synchronously,
      // skipItemInventoryFetch should be set as well to
      // skip the fetch triggered by `CART_UPDATED_V2`
      // AppEvent in CartDataStoreV2.
      skipItemInventoryFetch,
    });
